import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { backArrow } from '../../../../assets/images';
import { dsButtonLink, dsButtonPrimary, joinButtonClasses } from '../../../../utils/buttonStyles';

const OTP = ({requestAuth, resend_otp, login_path}) => {
  const history = useHistory()
  let [code, setCode] = useState('')

  return (
    <div className='my-4'>
      { login_path ?  <img src={backArrow} onClick={() => history.push('/login')} className='mb-3.5 cursor-pointer'/> : 
      <img src={backArrow} onClick={() => history.goBack()} className='mb-3.5 cursor-pointer'/>}
      <h1 className='font-fig-extrabold text-xl font-medium tracking-wider leading-8 text-gray-900 mb-0'>Enter OTP</h1>
      <p className='text-base text-gray-600 mt-3 mr-20 mb-0 w-96'>
        OTP has been sent to your registered e-mail
      </p>
      <span className='mb-3 mt-10 text-gray-500 text-sm font-semibold tracking-wider block'>OTP </span>
      <input
        id='otp'
        type='text'
        name='username'
        placeholder='Code'
        value={code}
        onChange={(e) => {setCode(e.target.value)}}
        className={
          'text-base caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-semibold pl-4 border border-gray-200 rounded-md w-96 h-14 bg-gray-100 focus:bg-gray-100 focus:ring-0  focus:outline-none focus:border-gray-400'
        }
      />
      <button
        onClick={() => requestAuth(code)}
        className={joinButtonClasses(dsButtonPrimary, 'mt-6 h-12 w-96')}
      >
        Submit
      </button>
      <div>
        <button
          onClick={() => resend_otp()}
          className={joinButtonClasses(dsButtonLink, 'mb-0 mt-6 w-max')}
          style={{marginLeft : '154px'}}
        >
          Resend OTP
        </button>
      </div>
    </div>
  )

}

export default OTP;
